<template>
  <b-modal
    centered
    scrollable
    hide-header-close
    no-close-on-backdrop
    no-close-on-esc
    size="md"
    id="mc-modal-reject"
    :title="$t('deliveryRequest.modal.rejectDelivery.title')"
  >
    <div class="mc-modal-reject card-body">
      <p class="mc-modal-reject__text">
        <span v-html="$t('deliveryRequest.modal.rejectDelivery.message', { companyName })"></span>
      </p>
      <p>{{ $t('deliveryRequest.modal.rejectDelivery.warning') }}</p>

      <FormulateInput
        v-model="rejectedReason"
        type="text"
        name="rejected_reason"
        :label="$t('deliveryRequest.modal.rejectDelivery.reasonLabel')"
        :placeholder="$t('deliveryRequest.modal.rejectDelivery.reasonPlaceholder')"
      />
    </div>

    <template #modal-footer="{ cancel }">
      <div class="d-flex mx-0 gap-2">
        <McButton :disabled="isLoading" @click="cancel" variant="secondary" :text="$t('global.no')" />
        <McButton :disabled="isLoading" @click="handleSubmit" :text="$t('deliveryRequest.modal.rejectDelivery.confirm')" />
      </div>
    </template>
  </b-modal>
</template>

<script>
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },
  inject: ['companyName'],
  emits: ['transition'],
  data() {
    return {
      isLoading: false,
      rejectedReason: '',
    }
  },
  methods: {
    handleSubmit() {
      this.isLoading = true

      const data = {
        status: 'REJECTED',
        fields: {
          rejected_reason: this.rejectedReason,
        },
      }

      this.$emit('transition', 'REJECT', data)
      this.isLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.mc-modal-reject {
  &__text {
    strong {
      font-weight: 600;
    }
  }
}
</style>
